import { isTextEmpty } from 'utils/helpers'
import {
  SET_PROGRESS,
  RESET_PROGRESS,
  SET_SERACH_VALUE,
  LOADING,
} from './constants'
import * as types from './constants'
import AxiosInstance from 'utils/AxiosInstance'
/*eslint-disable */
export const setProgress = (data) => ({ type: SET_PROGRESS, data })
export const resetProgress = () => ({ type: RESET_PROGRESS })
export const setSearchValue = (value) => ({ type: SET_SERACH_VALUE, value })
export const setHideCertificate = () => ({ type: types.SET_HIDE_CERTIFICATE })
export const setShowCertificate = (value) => {
  return {
    type: types.SET_SHOW_CERTIFICATE,
    value,
  }
}
export const setShowFeedback = (value) => ({
  type: types.SET_SHOW_FEEDBACK,
  value,
})

export const selectTab = (value) => ({
  type: types.SET_EMPLOYEE_SELECTED_TAB,
  value,
})

// const isLoading = false;

export const isLoading = (type, loadingType, isLoading) => ({
  type,
  loadingType,
  isLoading,
})

export const getReport = (id) => {
  return (dispatch) => {
    dispatch(isLoading(LOADING, 'isLoading', true))
    AxiosInstance.get(`/manager-reports/user/${id}`, {}).then((data) => {
      let coursesWithQuiz = []

      dispatch(setProgress(data))
      dispatch(isLoading(LOADING, 'isLoading', false))
    })
  }
}

export const getUserStores = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/stores/user-stores/${id}`).then((data) => {
      if (data) {
        dispatch({
          type: types.SET_EMPLOYEE_STORES,
          data: data.map((item) => item.name).join(' | '),
        })
      }
    })
  }
}

export const toggleDropdown = (index) => {
  return (dispatch, getState) => {
    const { progress } = getState().employeeReport

    progress.map((item) =>
      item.id === index ? (item.isShowing = true) : (item.isShowing = false)
    )

    dispatch(setProgress({ progress: progress }))
    dispatch(isLoading(LOADING, 'isLoading', false))
  }
}

export const markCompleted = () => {
  return (dispatch, getState) => {
    const { user, progress } = getState().employeeReport
    const item = progress.find((item) => item.isShowing)
    const activeIndex = progress.findIndex((item) => item.isShowing)

    AxiosInstance.post('/manager-reports/mark-course-completed', {
      user_id: user.id,
      course_id: item.id,
    }).then((data) => {
      const newProgress = [
        ...progress.slice(0, activeIndex),
        { ...item, status: data.status },
        ...progress.slice(activeIndex + 1),
      ]

      dispatch(setProgress({ progress: newProgress }))
      dispatch(isLoading(LOADING, 'isLoading', false))
    })
  }
}

export const markQuizPassed = () => {
  return (dispatch, getState) => {
    const { user, progress } = getState().employeeReport
    const item = progress.find((item) => item.isShowing)
    const activeIndex = progress.findIndex((item) => item.isShowing)

    AxiosInstance.post('/manager-reports/mark-quiz-passed', {
      user_id: user.id,
      course_id: item.id,
    }).then((data) => {
      const newProgress = [
        ...progress.slice(0, activeIndex),
        { ...item, status: data.status },
        ...progress.slice(activeIndex + 1),
      ]

      dispatch(setProgress({ progress: newProgress }))
      dispatch(isLoading(LOADING, 'isLoading', false))
    })
  }
}

export const clearAttempt = () => {
  return (dispatch, getState) => {
    const { user, progress } = getState().employeeReport
    const { language } = getState().language

    const item = progress.find((item) => item.isShowing)
    const activeIndex = progress.findIndex((item) => item.isShowing)

    AxiosInstance.post('/manager-reports/clear-attempt', {
      user_id: user.id,
      course_id: item.id,
      languageId: language.id,
    }).then((data) => {
      const newProgress = [
        ...progress.slice(0, activeIndex),
        { ...item, status: data.status },
        ...progress.slice(activeIndex + 1),
      ]

      dispatch(setProgress({ progress: newProgress }))
      dispatch(isLoading(LOADING, 'isLoading', false))
    })
  }
}

export const getExemptCourses = (id) => {
  return (dispatch, getState) => {
    // dispatch(isLoading(LOADING, 'isLoading', true))
    AxiosInstance.get(
      `/manager-reports/user/exempt-courses/${id}/extended`
    ).then((data) => {
      dispatch({ type: types.SET_EXEMPT_COURSES, data })
      // dispatch(isLoading(LOADING, 'isLoading', false))
    })
  }
}

export const setExemptCourses = () => {
  return (dispatch, getState) => {
    const { progress, exemptCourses } = getState().employeeReport
    const { users } = getState().users
    const exemptCoursesIds = exemptCourses.map((item) => item.course_id)
    let filteredProgress = progress

    filteredProgress.map((item) => {
      if (exemptCoursesIds.includes(item.course_id)) {
        item.isExempt = true
        const exemptCourse = exemptCourses.find(
          (exemptItem) => exemptItem.course_id === item.course_id
        )
        if (exemptCourse) {
          const exemptUser = exemptCourses.find(
            (item) =>
              item.manager && item.manager.id === exemptCourse.created_by
          )
          item.exemptDate = exemptCourse.created_at
          item.exemptBy = exemptUser
          item.exemptMessage = exemptCourse.message
        }
      }
    })
    dispatch({ type: types.SET_PROGRESS_FILTERED, data: filteredProgress })
  }
}

export const toggleReasonOverlay = (item) => {
  return (dispatch, getState) => {
    const { isShowingReason } = getState().employeeReport

    dispatch({
      type: types.SET_TOGGLE_REASON_OVERLAY,
      isShowingReason: !isShowingReason,
    })

    if (item) {
      dispatch({
        type: types.SET_CURRENT_SELECTED_COURSE,
        currentSelectedCourse: item,
      })
    } else {
      dispatch({
        type: types.SET_CURRENT_SELECTED_COURSE,
        currentSelectedCourse: null,
      })
      dispatch({ type: types.SET_MESSAGE, message: '' })
    }
  }
}

export const onChange = (value) => {
  return (dispatch) => {
    // const name = event.target.name
    // const value = event.target.value

    dispatch({ type: types.SET_MESSAGE, message: value })
  }
}

export const exemptCourse = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()
    const { message, user, currentSelectedCourse, progress, exemptCourses } =
      getState().employeeReport
    // const { users } = getState().user

    if (isTextEmpty(message)) {
      alert('Please specify a reason!')

      return
    }

    const data = {
      user_id: user.id,
      course_id: currentSelectedCourse.course_id,
      message,
    }
    AxiosInstance.post('/manager-reports/user/exempt-course', data).then(
      (returnData) => {
        let newProgress = progress

        newProgress.map((item) => {
          if (item.course_id === currentSelectedCourse.course_id) {
            const exemptUser = exemptCourses.find(
              (item) => item.manager.id === returnData.created_by
            )
            item.isExempt = true
            item.exemptMessage = message
            item.exemptBy = exemptUser
            item.exemptDate = returnData.created_at
          }
        })

        dispatch(toggleReasonOverlay())

        dispatch({
          type: types.SET_CURRENT_SELECTED_COURSE,
          currentSelectedCourse: null,
        })
        dispatch({ type: types.SET_PROGRESS_FILTERED, data: newProgress })
        dispatch(getExemptCourses(user.id))
      }
    )
  }
}

export const removeExemptCourse = (currentCourse) => {
  return (dispatch, getState) => {
    const { exemptCourses, progress, user } = getState().employeeReport
    const exemptCourse = exemptCourses.find(
      (exemptCourse) => exemptCourse.course_id === currentCourse.id
    )
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    // alert(language.alerts ? language.alerts.delete_confirm : null)
    alert('are you sure to remove the exempt!')
    AxiosInstance.delete(
      `/manager-reports/user/exempt-course/${exemptCourse.id}`
    ).then(() => {
      let newProgress = progress.map((item) => {
        if (item.course_id === currentCourse.course_id) {
          item.isExempt = false
          item.exemptMessage = ''
          item.exemptBy = {}
          item.exemptDate = ''
        }

        return item
      })

      dispatch({ type: types.SET_PROGRESS_FILTERED, data: newProgress })
      dispatch(getExemptCourses(user.id))
    })
  }
}

export const setShowSubmissionData = (currentCourseId, userId = '') => {
  return (dispatch, getState) => {
    let employeeId = getState().employeeReport.user.id

    if (!employeeId) {
      employeeId = userId
    }

    console.log(currentCourseId, userId, employeeId, 'leart299')

    dispatch({ type: types.SET_SUBMISSION_SHOWING, isShowingSubmission: true })

    AxiosInstance.get(
      `/courses/${currentCourseId}/submissions/${employeeId}`
    ).then((data) => {
      if (data && data.quiz) {
        dispatch({
          type: types.SET_CURRENT_SUBMISSION,
          currentSubmission: data,
        })
      }
    })
  }
}

export const setShowSubmissionDataManagerReport = (
  currentCourseId,
  employeeId
) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_SUBMISSION_SHOWING, isShowingSubmission: true })

    AxiosInstance.get(
      `/courses/${currentCourseId}/submissions/${employeeId}`
    ).then((data) => {
      dispatch({ type: types.SET_EMPLOYEE_ID, payload: employeeId })
      if (data && data.quiz) {
        dispatch({
          type: types.SET_CURRENT_SUBMISSION,
          currentSubmission: data,
        })
      }
    })
  }
}

export const setUserManually = (userId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/users/${userId}`).then((data) => {
      dispatch({ type: types.SET_USER_MANUALLY, payload: data })
    })
  }
}

export const setHideSubmissionData = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SUBMISSION_SHOWING, isShowingSubmission: false })
    dispatch({ type: types.SET_CURRENT_SUBMISSION, currentSubmission: null })
  }
}

export const getEmployeeLibrary = (sutdentId) => {
  return (dispatch, getState) => {
    const { employeeLibrary } = getState().employeeReport
    AxiosInstance.get(`/library/student/${sutdentId}`, {}).then((data) => {
      dispatch({ type: types.EMPLOYEE_LIBRARY, data })
    })
  }
}
